import {
  CreatedAt,
  CreateItemCacheKeys,
  CreateItemIsLoading,
  DeleteItemCacheKeys,
  FetchItemsCacheKey,
  FetchItemsEditItem,
  FetchItemsErrorMessage,
  FetchItemsFetched,
  FetchItemsFilterItems,
  FetchItemsIsPlaceholderData,
  FetchItemsLimit,
  FetchItemsPage,
  FetchItemsPaginateItems,
  FetchItemsPrefetchItems,
  FetchItemsSort,
  FetchItemsSortItems,
  FetchItemsTotalCount,
  ID,
  IDFilter,
  UpdatedAt,
  UpdateItemCacheKeys,
  UpdateItemIsLoading
} from '../../types';
import { ArchiAppSectionID } from '../archiAppSections/archiAppSectionsTypes';
import { RoleID } from '../roles/rolesTypes';
import { UserID } from '../users/usersTypes';

export type ArchiAppID = ID;
export type ArchiAppCreatedAt = CreatedAt;
export type ArchiAppUpdatedAt = UpdatedAt;
export type ArchiAppName = string;
export type ArchiAppUserID = UserID;
export type ArchiAppIframeUrl = string;
export type ArchiAppArchiAppSectionID = ArchiAppSectionID;
export type ArchiAppRoleID = RoleID;

export const enum FetchArchiAppsSortTypes {
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC'
}

export interface FetchArchiAppsFilters {
  archiAppSectionId?: IDFilter;
}

export type FetchArchiAppsFilterArchiApps =
  FetchItemsFilterItems<FetchArchiAppsFilters>;
export type FetchArchiAppsCacheKey = FetchItemsCacheKey;
export type FetchArchiAppsSort = FetchItemsSort;
export type FetchArchiAppsSortArchiApps = FetchItemsSortItems;
export type FetchArchiAppsPage = FetchItemsPage;
export type FetchArchiAppsLimit = FetchItemsLimit;
export type FetchArchiAppsErrorMessage = FetchItemsErrorMessage;
export type FetchArchiAppsFetched = FetchItemsFetched;
export type FetchArchiAppsIsPlaceholderData = FetchItemsIsPlaceholderData;
export type FetchArchiAppsPaginateArchiApps = FetchItemsPaginateItems;
export type FetchArchiAppsPrefetchArchiApps = FetchItemsPrefetchItems;
export type FetchArchiAppsTotalCount = FetchItemsTotalCount;

export type FetchArchiAppsEditArchiApp = FetchItemsEditItem;

export const enum FetchArchiAppsSortableFields {
  NAME = 'name',
  CREATED_AT = 'createdAt'
}

export type CreateArchiAppIsLoading = CreateItemIsLoading;
export type CreateArchiAppCacheKeys = CreateItemCacheKeys;

export type UpdateArchiAppIsLoading = UpdateItemIsLoading;
export type UpdateArchiAppCacheKeys = UpdateItemCacheKeys;

export type DeleteArchiAppCacheKeys = DeleteItemCacheKeys;
